import { observable } from 'mobx';
import { IInventoryQueryResponse } from 'src/internal/repositories/InventoryRepository';
import { LEGACY_INVENTORY_STATUS } from '../../constants/InventoryStatuses';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

const isLegacyStatus = (status: string | number) => !isNaN(Number(status));

export class Inventory {
    @observable public skuId: string = '';
    @observable public status: string;
    @observable public isUpdatedInventorySource?: boolean = false;
    @observable public highVelocityQuantity?: number;

    public static fromJson(inventory: IInventoryQueryResponse): Inventory {
        const newInventory = new Inventory();
        copyPropertiesExcludeNullsAndGetters(newInventory, inventory);

        if (
            isLegacyStatus(inventory.inventoryStatus) &&
            inventory.inventoryStatus in LEGACY_INVENTORY_STATUS
        ) {
            newInventory.status = LEGACY_INVENTORY_STATUS[inventory.inventoryStatus];
        }

        const highVelocityQuantity = inventory.highVelocityQuantity;
        if (highVelocityQuantity) {
            newInventory.highVelocityQuantity = highVelocityQuantity;
        }

        return newInventory;
    }
}
